import React from 'react';
import TableManager from '../components/data/TableManager';

const columnConfig = [
  "UTE_Id_Utenti=1,ID",
  "UTE_IdRif_Utenti=1,ID Rif.,type=number",
  "UTE_NomeUtente=2,Nome Utente",
  "UTE_Password=1,Password,type=password",
  "UTE_Crc=1,CRC",
  "UTE_Email=2,Email,type=email",
  "UTE_Id_GruppiAbilitazioni=2,Gruppo Abilitazioni", // Lookup
  "UTE_DurataSessione=1,Durata Sessione (min),type=number",
  "UTE_InizioValidita=1,Inizio Validità,type=datetime",
  "UTE_FineValidita=1,Fine Validità,type=datetime",
  "UTE_StatoRecord=2,Stato Record", // Lookup
  "UTE_UtenteInserimento=0,Utente Inserimento",
  "UTE_DataOraInserimento=0,Data/Ora Inserimento",
  "UTE_TerminaleInserimento=0,Terminale Inserimento",
  "UTE_UtenteModifica=0,Utente Modifica",
  "UTE_DataOraModifica=0,Data/Ora Modifica",
  "UTE_TerminaleModifica=0,Terminale Modifica",
  "UTE_Utente=0,Utente Audit",
  "UTE_Terminale=0,Terminale Audit",
  "UTE_Timestamp=0,Timestamp DB"
];

const filterConfig = [
  { field: 'UTE_NomeUtente', label: 'Nome Utente', type: 'text' },
  { field: 'UTE_Email', label: 'Email', type: 'text' },
  { field: 'UTE_Id_GruppiAbilitazioni', label: 'Gruppo Abilitazioni', type: 'lookup', lookupName: 'gruppiAbilitazioniLookup' },
  { field: 'UTE_StatoRecord', label: 'Stato Record', type: 'lookup', lookupName: 'statiRecordChar' },
];

const lookupConfig = {
  statiRecordChar: {
    options: [
      { value: 'A', label: 'Attivo' },
      { value: 'S', label: 'Sospeso' },
      { value: 'D', label: 'Disattivo' },
    ],
  },
  gruppiAbilitazioniLookup: {
    tableName: 'DOM_GruppiAbilitazioni',
    valueField: 'GAB_Id_GruppiAbilitazioni',
    labelField: 'GAB_Descrizione',
  }
};

const inputTypes = {
  UTE_Password: 'password',
  UTE_Email: 'email',
  UTE_DurataSessione: 'number',
  UTE_InizioValidita: 'datetime-local',
  UTE_FineValidita: 'datetime-local',
};

const UtentiPage = () => {
  return (
    <TableManager
      tableName="SKE_Utenti"
      primaryKey="UTE_Id_Utenti"
      pageTitle="Gestione utenti"
      columnConfig={columnConfig}
      filterConfig={filterConfig}
      lookupConfig={lookupConfig}
      inputTypes={inputTypes}
      enableCreate={true}
      enableEdit={true}
      enableDelete={true}
    />
  );
};

export default UtentiPage;